import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, StarIcon, ShoppingCartIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://pay.hotmart.com/R105070415Y?checkoutMode=10';
export function PricingSection() {
  return <section id="compra" className="bg-white py-16 md:py-20 px-4" data-id="element-206">
      <div className="max-w-3xl mx-auto" data-id="element-207">
        <div className="bg-gradient-to-b from-gray-900 to-gray-800 rounded-2xl p-6 md:p-10 shadow-2xl border border-amber-500/30" data-id="element-208">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-209">
            <ShoppingCartIcon className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-210" />
            <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-white leading-tight" data-id="element-211">
              MEGA PACK
              <br data-id="element-212" />
              MAESTRO HERRERO
            </h2>
            <p className="text-gray-400 mt-3 text-base" data-id="element-213">
              Descarga inmediata. Acceso de por vida.
            </p>
          </div>

          {/* Single Pricing Card */}
          <div className="bg-gray-800 border-2 border-amber-400 rounded-xl p-6 md:p-8 mb-8 ring-1 ring-amber-400/50" data-id="element-214">
            <div className="text-center mb-6" data-id="element-215">
              <div className="flex items-center justify-center gap-2 mb-3" data-id="element-216">
                <span className="text-2xl" data-id="element-217">🏆</span>
                <h3 className="font-heading font-bold text-white text-2xl" data-id="element-218">
                  PACK COMPLETO
                </h3>
              </div>
              <div className="flex items-center justify-center gap-2 flex-wrap mb-4" data-id="element-219">
                <span className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-220">
                  OFERTA ESPECIAL
                </span>
                <span className="bg-amber-500 text-black text-xs font-bold px-3 py-1 rounded-full" data-id="element-221">
                  MEJOR VALOR
                </span>
              </div>

              <div className="mb-6" data-id="element-222">
                <p className="text-gray-500 line-through text-lg mb-2" data-id="element-223">
                  USD $97.00
                </p>
                <p className="font-heading font-extrabold text-amber-400 text-5xl md:text-6xl mb-2" data-id="element-224">
                  USD $9.97
                </p>
                <p className="text-green-400 font-semibold text-sm" data-id="element-225">
                  💳 Paga en tu moneda local
                </p>
              </div>
            </div>

            <div className="space-y-3 mb-6" data-id="element-226">
              <div className="flex items-center gap-2" data-id="element-227">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-228" />
                <span className="text-gray-200" data-id="element-229">+1000 planos industriales</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-230">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-231" />
                <span className="text-gray-200" data-id="element-232">Herrería Artística</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-233">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-234" />
                <span className="text-gray-200" data-id="element-235">Carpintería que Vende</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-236">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-237" />
                <span className="text-gray-200" data-id="element-238">Tornería desde Cero</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-239">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-240" />
                <span className="text-gray-200" data-id="element-241">
                  Presupuesto + Ventas por WhatsApp
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-242">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-243" />
                <span className="text-gray-200" data-id="element-244">Soldadura desde Cero</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-245">
                <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-246" />
                <span className="text-gray-200" data-id="element-247">
                  Planos Premium Máquinas Gym y Trailer
                </span>
              </div>

              <div className="border-t border-gray-600 pt-4 mt-4" data-id="element-248">
                <div className="flex items-center gap-2" data-id="element-249">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-250" />
                  <span className="text-gray-200" data-id="element-251">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2 mt-2" data-id="element-252">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-253" />
                  <span className="text-gray-200" data-id="element-254">Descarga digital</span>
                </div>
                <div className="flex items-center gap-2 mt-2" data-id="element-255">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-256" />
                  <span className="text-gray-200" data-id="element-257">Acceso de por vida</span>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <CTAButton href={CHECKOUT_URL} className="max-w-lg mx-auto" data-id="element-258">
            🛒 COMPRAR AHORA
          </CTAButton>
          <p className="text-center text-gray-500 text-xs mt-3" data-id="element-259">
            Descarga inmediata · Garantía de 7 días
          </p>

          <div className="mt-4 flex items-center justify-center gap-2 text-gray-500 text-xs" data-id="element-260">
            <span data-id="element-261">🔒</span>
            <span data-id="element-262">Pago seguro · Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}